import { useCommonQuery } from "./common-query";

export const useSideNavigation = () => {
  const { navSegment } = useCommonQuery();

  return navSegment;
};